import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { RxDashboard } from 'react-icons/rx'
import { FiUsers, FiUser, FiLogOut, FiShield, FiTv } from 'react-icons/fi'
import { FaBarsStaggered } from 'react-icons/fa6'
import { LuLayoutList } from 'react-icons/lu'
import { PiPassword } from 'react-icons/pi'
import { MdDoubleArrow } from 'react-icons/md'
import { AppContext } from '../contexts/AppContext'
import { PiUserCircleLight } from 'react-icons/pi'
import { TbPlayFootball } from 'react-icons/tb'
// import { IoSettingsOutline } from 'react-icons/io5'
import { MdOutlineAnalytics } from 'react-icons/md'
import { LuSettings2 } from 'react-icons/lu'
import { HiOutlineDocumentReport } from 'react-icons/hi'
// import { AuthContext } from '../contexts/AuthContext'
// import { IoIosFootball } from 'react-icons/io'
import { FaShieldAlt, FaFilePdf } from 'react-icons/fa'

const AppLayout = ({ children, pageName }) => {
  const navigate = useNavigate()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const sidebarRef = useRef(null)
  const { userToken, logout } = useContext(AppContext)
  // const { userToken } = useContext(AuthContext);
  const isGuestUser =
    !!userToken &&
    (userToken.is_guest === 1 || userToken.is_guest === true || userToken.isGuest === 1 || userToken.isGuest === true)

  useEffect(() => {
    if (userToken === null) {
      navigate('/')
    }
  }, [navigate, userToken])

  const handleLogout = async () => {
    const response = await logout()
    if (response === 'success') {
      navigate('/')
    }
  }

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  //   // Callback ref to ensure we get the latest node
  //   const setSidebarRef = useCallback((node) => {
  //     sidebarRef.current = node;
  //   }, []);

  //   useEffect(() => {
  //     // Function to check if clicked outside of sidebar
  //     const handleClickOutside = (event) => {
  //       alert("test");
  //       if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
  //         setIsSidebarOpen(false);
  //       }
  //     };

  //     // Add event listener
  //     document.addEventListener("mousedown", handleClickOutside);

  //     // Clean up
  //     return () => {
  //       document.removeEventListener("mousedown", handleClickOutside);
  //     };
  //   }, [sidebarRef]);

  return (
    <>
      {userToken !== null ? (
        <div
          className={`d-flex ${isSidebarOpen ? 'toggled' : ''}`}
          id='wrapper'
          ref={sidebarRef}
        >
          <div
            id='sidebar-wrapper'
            className='my-2 top-0'
          >
            <div className='sidebar-heading'>
              <img
                src='/favi.png'
                className='w-9 invert logo-sm'
                alt=''
              />
              <img
                src='/logo.png'
                className='p-0 invert logo'
                alt=''
              />
              <button
                className='btn'
                onClick={handleSidebarToggle}
                id='menu-toggle'
              >
                <MdDoubleArrow
                  color='#FFF'
                  size={42}
                />
              </button>
            </div>
            <div className='list-group list-group-flush pt-1.5 pb-3'>
              {isGuestUser ? (
                <>
                  <div className='w-100'>
                    <div className='px-2 d-flex'>
                      <Link
                        to='/report-infringement'
                        className={`nav-main ${pageName === 'Report Infringement' ? 'active-link' : ''}`}
                      >
                        <div className='nav-hide'>
                          <HiOutlineDocumentReport /> Report Infringement
                        </div>
                        <div className='nav-icon'>
                          <HiOutlineDocumentReport />
                        </div>
                      </Link>
                      <Link
                        to='/'
                        className='nav-main'
                      >
                        <div className='nav-hide'>
                          <FiUser /> Logout
                        </div>
                        <div className='nav-icon'>
                          <FiUser />
                        </div>
                      </Link>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className='w-100'>
                    <div className='px-2 d-flex'>
                      <Link
                        to='/dashboard'
                        className={`nav-main ${pageName === 'Home' ? 'active-link' : ''}`}
                      >
                        <div className='nav-hide'>
                          <RxDashboard /> Home
                        </div>
                        <div className='nav-icon'>
                          <RxDashboard />
                        </div>
                      </Link>
                      {userToken.type === 'Admin' ? (
                        <>
                          <Link
                            to='/overview'
                            className={`nav-main ${pageName === 'Overview' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <MdOutlineAnalytics /> Overview
                            </div>
                            <div className='nav-icon'>
                              <MdOutlineAnalytics />
                            </div>
                          </Link>
                          <Link
                            to='/report'
                            className={`nav-main ${pageName === 'Matchdays Report' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <HiOutlineDocumentReport /> Matchdays Report
                            </div>
                            <div className='nav-icon'>
                              <HiOutlineDocumentReport />
                            </div>
                          </Link>
                          <Link
                            to='/all-members'
                            className={`nav-main ${
                              pageName === 'All Members' ||
                              pageName === 'Add New Member' ||
                              pageName === 'Update Member'
                                ? 'active-link'
                                : ''
                            }`}
                          >
                            <div className='nav-hide'>
                              <FiUsers /> Members
                            </div>
                            <div className='nav-icon'>
                              <FiUsers />
                            </div>
                          </Link>
                          <Link
                            to='/all-matches'
                            className={`nav-main ${
                              pageName === 'All Matches' || pageName === 'Match Details' || pageName === 'Add New Match'
                                ? 'active-link'
                                : ''
                            }`}
                          >
                            <div className='nav-hide'>
                              <LuLayoutList /> Matches
                            </div>
                            <div className='nav-icon'>
                              <LuLayoutList />
                            </div>
                          </Link>
                          <Link
                            to='/teams'
                            className={`nav-main ${
                              pageName === 'All Teams' || pageName === 'Team Details' ? 'active-link' : ''
                            }`}
                          >
                            <div className='nav-hide'>
                              <TbPlayFootball /> All Teams
                            </div>
                            <div className='nav-icon'>
                              <TbPlayFootball />
                            </div>
                          </Link>
                          <Link
                            to='/competitions'
                            className={`nav-main ${pageName === 'All Competitions' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <TbPlayFootball /> All Competitions
                            </div>
                            <div className='nav-icon'>
                              <TbPlayFootball />
                            </div>
                          </Link>
                          <Link
                            to='/all-admins'
                            className={`nav-main ${
                              pageName === 'All Admins' || pageName === 'Add New Admin' || pageName === 'Update Admin'
                                ? 'active-link'
                                : ''
                            }`}
                          >
                            <div className='nav-hide'>
                              <FiUsers /> Admins
                            </div>
                            <div className='nav-icon'>
                              <FiUsers />
                            </div>
                          </Link>
                          <Link
                            to='/vpn'
                            className={`nav-main ${pageName === 'VPN' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <FaShieldAlt /> VPN
                            </div>
                            <div className='nav-icon'>
                              <FaShieldAlt />
                            </div>
                          </Link>
                          <Link
                            to='/infringing-urls'
                            className={`nav-main ${pageName === 'Infringing URLs' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <HiOutlineDocumentReport /> Infringing URLs
                            </div>
                            <div className='nav-icon'>
                              <HiOutlineDocumentReport />
                            </div>
                          </Link>
                          <Link
                            to='/allow-listed-accounts'
                            className={`nav-main ${pageName === 'Allowlist' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <FiShield /> Allow List
                            </div>
                            <div className='nav-icon'>
                              <FiShield />
                            </div>
                          </Link>
                          <Link
                            to='/iptv'
                            className={`nav-main ${pageName === 'IPTV' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <FiTv /> IPTV
                            </div>
                            <div className='nav-icon'>
                              <FiTv />
                            </div>
                          </Link>
                        </>
                      ) : (
                        ''
                      )}

                      {userToken.type === 'Member' && (
                        <>
                          {/* <Link
                            to='/dashboard'
                            className={`nav-main ${pageName === 'Match Details' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <IoIosFootball />
                              Competitions
                            </div>
                            <div className='nav-icon'>
                              <IoIosFootball />
                            </div>
                          </Link> */}
                          <Link
                            to='/overview'
                            className={`nav-main ${pageName === 'Aperçu' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <MdOutlineAnalytics /> Overview
                            </div>
                            <div className='nav-icon'>
                              <MdOutlineAnalytics />
                            </div>
                          </Link>
                          <Link
                            to='/report'
                            className={`nav-main ${pageName === 'Matchdays Report' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <HiOutlineDocumentReport /> Matchdays Report
                            </div>
                            <div className='nav-icon'>
                              <HiOutlineDocumentReport />
                            </div>
                          </Link>
                          <Link
                            to='/teams'
                            className={`nav-main ${
                              pageName === 'All Teams' || pageName === 'Team Details' ? 'active-link' : ''
                            }`}
                          >
                            <div className='nav-hide'>
                              <TbPlayFootball /> All Teams
                            </div>
                            <div className='nav-icon'>
                              <TbPlayFootball />
                            </div>
                          </Link>
                          <Link
                            to='/vpns'
                            className={`nav-main ${pageName === 'Available VPNs' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <FaShieldAlt /> VPN's List
                            </div>
                            <div className='nav-icon'>
                              <FaShieldAlt />
                            </div>
                          </Link>
                          <Link
                            to='/vpn-reports'
                            className={`nav-main ${pageName === 'VPN Reports' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <FaFilePdf /> VPN Reports
                            </div>
                            <div className='nav-icon'>
                              <FaFilePdf />
                            </div>
                          </Link>
                          <Link
                            to='/report-infringement'
                            className={`nav-main ${pageName === 'Report Infringement' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <HiOutlineDocumentReport /> Report Infringement
                            </div>
                            <div className='nav-icon'>
                              <HiOutlineDocumentReport />
                            </div>
                          </Link>
                          <Link
                            to='/allow-listed-accounts'
                            className={`nav-main ${pageName === 'Allowlist' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <FiShield /> Allow List
                            </div>
                            <div className='nav-icon'>
                              <FiShield />
                            </div>
                          </Link>
                          <Link
                            to='/iptv'
                            className={`nav-main ${pageName === 'IPTV' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <FiTv /> IPTV
                            </div>
                            <div className='nav-icon'>
                              <FiTv />
                            </div>
                          </Link>
                        </>
                      )}
                    </div>
                    <div className='border-top px-2 d-flex'>
                      <br />
                      <p>
                        <i className='fas fa-minus fa-sm'></i>&nbsp; My Account
                      </p>
                      <Link
                        to='/profile'
                        className={`nav-main ${pageName === 'My Account' ? 'active-link' : ''}`}
                      >
                        <div className='nav-hide'>
                          <FiUser /> My Account
                        </div>
                        <div className='nav-icon'>
                          <FiUser />
                        </div>
                      </Link>
                      <Link
                        to='/change-password'
                        className={`nav-main ${pageName === 'Change Password' ? 'active-link' : ''}`}
                      >
                        <div className='nav-hide'>
                          <PiPassword /> Change Password
                        </div>
                        <div className='nav-icon'>
                          <PiPassword />
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className='w-100'>
                    <div className='border-top px-2 d-flex'>
                      <br />
                      {userToken.type === 'Admin' && (
                        <>
                          {/* <p>
                            <i className="fas fa-minus fa-sm"></i>&nbsp; Configuration
                          </p> */}
                          <Link
                            to='/edit-matchday-data'
                            className={`nav-main ${pageName === 'Matchday Data' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <LuSettings2 /> Matchday Data
                            </div>
                            <div className='nav-icon'>
                              <LuSettings2 />
                            </div>
                          </Link>
                          <Link
                            to='/edit-websites-links'
                            className={`nav-main ${pageName === 'Websites Links' ? 'active-link' : ''}`}
                          >
                            <div className='nav-hide'>
                              <LuSettings2 /> Websites Links
                            </div>
                            <div className='nav-icon'>
                              <LuSettings2 />
                            </div>
                          </Link>
                        </>
                      )}
                      <Link
                        to='/'
                        className='nav-main'
                        onClick={handleLogout}
                      >
                        <div className='nav-hide'>
                          <FiLogOut /> Logout
                        </div>
                        <div className='nav-icon'>
                          <FiLogOut />
                        </div>
                      </Link>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <div
            id='page-content-wrapper'
            className='flex flex-col'
          >
            <div className='flex-1 shrink-0 p-2'>
              <nav className='navbar navbar-expand-lg bg-main flex items-center'>
                <span
                  id='menu-toggle-sm'
                  onClick={handleSidebarToggle}
                >
                  <FaBarsStaggered
                    color='#FFF'
                    size={22}
                  />
                </span>
                <div className='page-head ml-3'>
                  <h4>{pageName !== '' ? pageName : ''}</h4>
                </div>
                <div className='ml-auto max-sm:hidden'>
                  <div className='btn-nav-user'>
                    <PiUserCircleLight size={44} />
                    <div>
                      <h6>{userToken.name}</h6>
                      <Link
                        to='/'
                        onClick={handleLogout}
                      >
                        Logout
                      </Link>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
            <div className='content-scrollable'>{children}</div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default AppLayout
